module.exports = __webpack_public_path__ + "b51c6615eeff844d10cfb9b72eaa1515.webp";